import ChangeLanguage from "@/components/changeLanguage.vue"

const zh = {
    Language: '中文',
    Login: {
      rememberMe: '记住账号',
      login: '登录',
      enterUsername: '请输入您的账号',
      enterPassword: '请输入您的密码'
    },
    headLine:'{CNtitle}',//标题
    navTopTitle:'{title}',//导航栏
    navTitle:'{title}',//导航栏
    companyInfo:'{title}',//公司信息
    jobPosting:'{title}',//导航栏
    allTitle:'{title}',//导航栏
     WeChatTitle:'微信公众号',
     record:'备案号',
     follow:'关注瑞集公众号',
     getInfo:'随时获取瑞集最新资讯',
     descriptionInfo:'科技温暖生活 智慧赋能未来',
      copyright:'版权所有@广东瑞集物联网科技有限公司',
      employeeRecruitment:'职员招聘',
      employeedescript:'瑞集科技珍视人才，坚信人才是推动公司发展的核心力量。',
      changeLanguage:'切换语言',
      allProduct:'全部产品',
      sumbitTitle:'立即提交',
      aboutRuiji:require('../../../public/image/image.png')
  }
  export default zh